import FilterSelect from "./FilterSelect";

const SimulationLibrarySidebar = ({
  filterOptions,
  selectedFilters,
  search,
  isShowLastTwelveMonths,
  onSearchInput,
  onSearch,
  onFilterClick,
  onChangeLastMonth,
  showLastTwelveMonthsCheckbox = true,
  searchClassName = "mainSearchBoxDiv col-sm-12",
  searchInputClassName = "search-box-view fields-font",
}) => (
  <div className="simulation-sidebar">
    {showLastTwelveMonthsCheckbox && (
      <div className="form-group row">
        <div className="col-sm-12">
          <div className="form-check">
            <input
              type="checkbox"
              name="isShowLastTwelveMonths"
              id="isShowLastTwelveMonths"
              className="form-check-input custom-check-box-xl"
              checked={isShowLastTwelveMonths}
              onChange={onChangeLastMonth}
            />
            <label className="form-check-label ml-1">
              Show Last 12 Month Released Simulations
            </label>
          </div>
        </div>
      </div>
    )}

    <div className="form-group row">
      <form className={searchClassName} noValidate={true}>
        <input
          type="search"
          className={searchInputClassName}
          placeholder=" Search …"
          name="search"
          value={search}
          onChange={onSearchInput}
        />
        <button type="submit" className="searchBtn buttons" onClick={onSearch}>
          <i className="fa fa-search" />
        </button>
      </form>
    </div>

    <div className="form-group row">
      <div className="col-12" style={{ textAlign: "right" }}>
        <button
          type="button"
          className="btn-submit btn-lg buttons"
          onClick={onFilterClick}
        >
          Filter <i className=" fa fa-filter" />
        </button>
      </div>
    </div>

    {Object.entries(filterOptions).map(([filterKey, config]) => (
      <FilterSelect
        key={filterKey}
        label={config.label}
        name={filterKey}
        options={config.options}
        value={selectedFilters[filterKey]}
        onChange={config.onChange}
        placeholder={config.placeholder}
      />
    ))}
  </div>
);

export default SimulationLibrarySidebar;
